import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { UpdateWorkspaceTimeZoneForm } from '../components/UpdateWorkspaceTimeZoneForm';
import { IUpdateWorkspaceTimeZoneBl } from '../UpdateWorkspaceTimeZone.bl';
import { IUpdateWorkspaceTimeZoneStore } from '../UpdateWorkspaceTimeZone.store';

export const UpdateWorkspaceTimeZoneFormContainer = observer((): ReactElement => {
  const store = useInjection(IUpdateWorkspaceTimeZoneStore.$);
  const bl = useInjection(IUpdateWorkspaceTimeZoneBl.$);

  const handleTimeZoneChanged = (timeZone: number): void => {
    bl.selectTimeZone(timeZone);
  };

  return (
    <UpdateWorkspaceTimeZoneForm
      onTimeZoneChanged={handleTimeZoneChanged}
      selectedTimeZone={store.selectedTimeZoneOffset}
    />
  );
});
